// src/utils/sanitize.js
// HTML sanitization for user-generated rich text (TipTap output).
// Strips dangerous tags/attributes while preserving safe formatting.

import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'b', 'em', 'i', 'u',
  'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4',
  'a', 'blockquote', 'hr',
];

const ALLOWED_ATTR = ['href', 'target', 'rel'];

/**
 * Sanitize user-generated HTML for safe rendering via dangerouslySetInnerHTML.
 * Strips <script>, <iframe>, event handlers, javascript: URLs, etc.
 *
 * @param {string} html - Raw HTML string (e.g. from TipTap editor)
 * @returns {string} Sanitized HTML safe for rendering
 */
export function sanitizeHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}
